(function () {
  'use strict';

  /* =========================================
     CONFIG — YOU MUST SET THESE 2 VALUES
     ========================================= */
  const TTQP_CONFIG = {
    SUB_VARIANT_ID: 42972107669565,   // subscription parent variant id
    SELLING_PLAN_ID: 15601107005,  // Appstle selling plan id

    MONTHS_COUNT: 12,
    EMPTY_LABEL: 'Scent of the month',
    STORAGE_KEY: 'ttqp_queue_12m',
    CLEAR_CART_BEFORE_ADD: false
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* =========================================
     Helpers
     ========================================= */
  function ymKeyFromDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    return `${y}-${m}`;
  }

  function shortMonthLabelFromYM(ym) {
    const [y, m] = ym.split('-').map(Number);
    const dt = new Date(y, m - 1, 1);
    return dt.toLocaleString('en-US', { month: 'short', year: 'numeric' });
  }

  function getNextMonths(count) {
    const out = [];
    const start = new Date();
    start.setMonth(start.getMonth() + 1);
    start.setDate(1);

    for (let i = 0; i < count; i++) {
      const d = new Date(start);
      d.setMonth(start.getMonth() + i);
      out.push(ymKeyFromDate(d));
    }
    return out;
  }

  function loadQueue() {
    try { return JSON.parse(localStorage.getItem(TTQP_CONFIG.STORAGE_KEY) || '{}'); }
    catch { return {}; }
  }

  function saveQueue(queue) {
    localStorage.setItem(TTQP_CONFIG.STORAGE_KEY, JSON.stringify(queue));
  }

  function findNextEmptyMonth(queue, months) {
    for (const ym of months) if (!queue[ym]) return ym;
    return null;
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function hydrateConfigFromDOM() {
  const el = document.querySelector('.ttqp[data-sub-variant-id]');
  if (!el) return;

  const v = el.getAttribute('data-sub-variant-id');
  const p = el.getAttribute('data-selling-plan-id');

  TTQP_CONFIG.SUB_VARIANT_ID = v ? Number(v) : null;
  TTQP_CONFIG.SELLING_PLAN_ID = p ? Number(p) : null;
}

  /* =========================================
     Queue list/compact helpers
     ========================================= */
  function compactQueueToList(queue) {
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    const list = [];
    for (const ym of months) {
      if (queue[ym]) list.push(queue[ym]);
    }
    return list;
  }

  function listToQueue(list) {
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    const newQueue = {};
    months.forEach((ym, idx) => {
      if (list[idx]) newQueue[ym] = list[idx];
    });
    return newQueue;
  }

  // ✅ Popup remove (remove by month index, then shift left)
  function removeMonthAndShift(ymToRemove) {
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    const queue = loadQueue();

    const removeIndex = months.indexOf(ymToRemove);
    if (removeIndex === -1 || !queue[ymToRemove]) return;

    const ordered = months.map(ym => queue[ym] || null);
    ordered[removeIndex] = null;

    const compacted = ordered.filter(Boolean);
    saveQueue(listToQueue(compacted));

    renderCarousel();
    updateSelectionCount();
    
    
  }

  // ✅ Grid remove (remove first matching variant only, then shift left)
  function removeVariantAndShift(variantId) {
    if (!variantId) return;

    const queue = loadQueue();
    const list = compactQueueToList(queue);

    const idx = list.findIndex(item => String(item.variantId || '') === String(variantId));
    if (idx === -1) return;

    list.splice(idx, 1);
    saveQueue(listToQueue(list));

    renderCarousel();
    updateSelectionCount();
  }

  /* =========================================
     Grid sync (Added state)
     ========================================= */
  function syncGridButtonsWithQueue() {
    const queue = loadQueue();
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);

    const queued = new Set();
    for (const ym of months) {
      if (queue[ym] && queue[ym].variantId) queued.add(String(queue[ym].variantId));
    }

    $$('[data-ttqp-queuebtn]').forEach((wrap) => {
      const addBtn = $('.ttqp-add-to-queue', wrap);
      const addedUI = $('[data-ttqp-added]', wrap);
      if (!addBtn || !addedUI) return;

      const vid = addBtn.getAttribute('data-variant-id');
      const isQueued = vid && queued.has(String(vid));

      addBtn.style.display = isQueued ? 'none' : '';
      addedUI.style.display = isQueued ? '' : 'none';
    });
  }

  /* =========================================
     Modal
     ========================================= */
  function ensureModal() {
    if ($('#ttqpModal')) return;

    const modalHtml = `
      <div id="ttqpModal" class="ttqp-modal" aria-hidden="true">
        <div class="ttqp-modal__backdrop" data-ttqp-close></div>

        <div class="ttqp-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ttqpTitle" tabindex="-1">
          <button class="ttqp-modal__close" type="button" aria-label="Close" data-ttqp-close>×</button>

          <h3 id="ttqpTitle" class="ttqp-modal__title">Fragrances you have added Successfully!</h3>

          <div class="ttqp-carousel-wrap">
            <button class="ttqp-nav" type="button" data-ttqp-prev aria-label="Previous">‹</button>
            <div class="ttqp-carousel" id="ttqpCarousel" tabindex="0" aria-label="12 month queue carousel"></div>
            <button class="ttqp-nav" type="button" data-ttqp-next aria-label="Next">›</button>
          </div>

          <p class="ttqp-note">
            Your plan is flexible! You can update your fragrance choices or cancel anytime without consequences
          </p>

          <p class="ttqp-subnote">If you haven't chosen your scent, you will receive scent of the month chosen by us. </p>

          <div class="ttqp-actions">
            <button class="ttqp-primary" type="button" id="ttqpSubscribeNow">Subscribe Now</button>
            <button class="ttqp-secondary" type="button" data-ttqp-close>I Want to See More Fragrances</button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHtml);
  }

  function openModal() {
    const m = $('#ttqpModal');
    if (!m) return;
    renderCarousel();
    updateSelectionCount();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    const dialog = $('.ttqp-modal__dialog', m);
    dialog && dialog.focus();
  }

  function closeModal() {
    const m = $('#ttqpModal');
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
  }

  function renderCarousel() {
    const el = $('#ttqpCarousel');
    if (!el) return;

    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    const queue = loadQueue();

    el.innerHTML = months.map((ym) => {
      const entry = queue[ym];
      const badge = shortMonthLabelFromYM(ym);

      if (entry) {
        const imgHtml = entry.image
          ? `<img src="${escapeHtml(entry.image)}" alt="${escapeHtml(entry.title)}">`
          : `<div class="ttqp-plus" aria-hidden="true">✓</div>`;

        return `
          <div class="ttqp-month-card" data-ym="${escapeHtml(ym)}">
            <button class="ttqp-month-x" type="button" aria-label="Remove" data-ttqp-remove-month data-ym="${escapeHtml(ym)}">×</button>
            <div class="ttqp-thumb">${imgHtml}</div>
            <div class="ttqp-name">${escapeHtml(entry.title)}</div>
            <div class="ttqp-badge">${escapeHtml(badge)}</div>
          </div>
        `;
      }

            return `
        <button
          class="ttqp-month-card ttqp-month-card--empty"
          type="button"
          data-ym="${escapeHtml(ym)}"
          data-ttqp-close
          aria-label="See more fragrances for ${escapeHtml(badge)}"
        >
          <div class="ttqp-thumb"><div class="ttqp-plus" aria-hidden="true">+</div></div>
          <div class="ttqp-name">${escapeHtml(TTQP_CONFIG.EMPTY_LABEL)}</div>
          <div class="ttqp-badge">${escapeHtml(badge)}</div>
        </button>
      `;
      
    /*
      return `
        <div class="ttqp-month-card" data-ym="${escapeHtml(ym)}">
          <div class="ttqp-thumb"><div class="ttqp-plus" aria-hidden="true">+</div></div>
          <div class="ttqp-name">${escapeHtml(TTQP_CONFIG.EMPTY_LABEL)}</div>
          <div class="ttqp-badge">${escapeHtml(badge)}</div>
        </div>
      `; */
    }).join('');

    syncGridButtonsWithQueue();
  }

  /* =========================================
     Add to Queue
     ========================================= */
  function addSelectionToQueue(selection) {
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    const queue = loadQueue();

    // prevent duplicates
    if (selection.variantId) {
      for (const ym of months) {
        if (queue[ym] && String(queue[ym].variantId || '') === String(selection.variantId)) {
          syncGridButtonsWithQueue();
        updateSelectionCount();
        // openModal();
          return;
        }
      }
    }

    const targetYM = findNextEmptyMonth(queue, months);
    if (!targetYM) queue[months[months.length - 1]] = selection;
    else queue[targetYM] = selection;

    saveQueue(queue);
    syncGridButtonsWithQueue();
    updateSelectionCount();
    //openModal();
  }

  function bindQueueButtons(root = document) {
    const buttons = root.querySelectorAll('.ttqp-add-to-queue');
    buttons.forEach((btn) => {
      if (btn.dataset.ttqpBound === '1') return;
      btn.dataset.ttqpBound = '1';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const title = btn.getAttribute('data-title') || 'Selected fragrance';
        const image = btn.getAttribute('data-image') || '';
        const variantId = btn.getAttribute('data-variant-id') || '';
        addSelectionToQueue({ title, image, variantId });
        updateSelectionCount();
      });
    });
  }

  /* =========================================
     Tabs
     ========================================= */
  
     function setActiveTab(section, id, preserveSearch = false) {
  const tabs = $$('[data-ttqp-tab]', section);
  const panels = $$('[data-ttqp-panel]', section);

  tabs.forEach(t => {
    const active = t.getAttribute('data-ttqp-tab') === id;
    t.classList.toggle('is-active', active);
    t.setAttribute('aria-selected', active ? 'true' : 'false');
    // if (active) {
    //   t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    // }
  });

  panels.forEach(p => {
    p.classList.toggle('is-active', p.getAttribute('data-ttqp-panel') === id);
  });

  const search = $('[data-ttqp-search]', section);

  // Only clear search on manual tab switching, not when search itself changes tabs
  if (!preserveSearch && search) {
    search.value = '';
    applySearchFilter(section, '');
  }

  updateSelectionCount();
  syncGridButtonsWithQueue();
}

 /*function setActiveTab(section, id) {
    const tabs = $$('[data-ttqp-tab]', section);
    const panels = $$('[data-ttqp-panel]', section);

    tabs.forEach(t => {
      const active = t.getAttribute('data-ttqp-tab') === id;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    });

    panels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-ttqp-panel') === id));

    // clear search on tab switch
    const search = $('[data-ttqp-search]', section);
    if (search) {
      search.value = '';
      applySearchFilter(section, '');
    }
  }*/

function initTabs() {
  $$('.ttqp').forEach((section) => {
    const tabs = $$('[data-ttqp-tab]', section);

    tabs.forEach(tab => {
      tab.addEventListener('click', async () => {

        const id = tab.getAttribute('data-ttqp-tab');
        setActiveTab(section, id);

        const panel = section.querySelector(`[data-ttqp-panel="${id}"]`);
        if (!panel) return;

        const state = ensurePanelState(panel);
        const grid = panel.querySelector('[data-ttqp-grid]');
        if (!grid) return;

        const source = panel.getAttribute('data-ttqp-source');

        // Only run for collection tabs
        if (source !== 'collection') return;

        const pageSize = Number(panel.getAttribute('data-page-size') || 6);

        // Already initialized
        if (state.loadedCount > 0) return;

        const allProducts = await ensureAllCollectionProductsForPanel(panel);

        state.loadedCount = pageSize;

        const visibleProducts = allProducts.slice(0, state.loadedCount);

        grid.innerHTML = renderProductCardsHTML(visibleProducts);

        bindQueueButtons(panel);
        syncGridButtonsWithQueue();
        updateSelectionCount();
      });
    });

    // Load first tab automatically
    const firstTab = tabs[0];
    if (firstTab) firstTab.click();
  });
}

  /* =========================================
     Search
     ========================================= */

     function applySearchFilter(section, query) {
  const q = (query || '').trim().toLowerCase();
  const panels = $$('[data-ttqp-panel]', section);
  const tabs = $$('[data-ttqp-tab]', section);

  let firstMatchedPanelId = null;

  panels.forEach((panel) => {
    const cards = $$('[data-ttqp-card]', panel);
    const loadMoreBtn = $('[data-ttqp-load-more]', panel);

    if (q.length > 0) {
      cards.forEach(card => card.classList.remove('is-hidden'));
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    } else {
      if (loadMoreBtn) loadMoreBtn.style.display = '';
    }

    let visibleCount = 0;

    cards.forEach((card) => {
      const title = (card.getAttribute('data-title') || '').toLowerCase();
      const match = q === '' ? true : title.includes(q);
      card.classList.toggle('is-filtered', !match);
      if (match) visibleCount++;
    });

    let empty = $('.ttqp__search-empty', panel);
    if (!empty) {
      panel.insertAdjacentHTML(
        'beforeend',
        `<p class="ttqp__empty ttqp__search-empty" style="display:none;margin-top:14px;">No matching scents found.</p>`
      );
      empty = $('.ttqp__search-empty', panel);
    }

    empty.style.display = (q && visibleCount === 0) ? 'block' : 'none';

    if (q && visibleCount > 0 && !firstMatchedPanelId) {
      firstMatchedPanelId = panel.getAttribute('data-ttqp-panel');
    }
  });

  // While searching: switch to first tab that has a match
  if (q.length > 0 && firstMatchedPanelId) {
    setActiveTab(section, firstMatchedPanelId, true);
  }
}

function restorePanelAfterSearch(panel) {
  const state = ensurePanelState(panel);
  const grid = $('[data-ttqp-grid]', panel);
  if (!grid) return;

  if (state.allProducts && state.loadedCount > 0) {
    const visibleProducts = state.allProducts.slice(0, state.loadedCount);
    grid.innerHTML = renderProductCardsHTML(visibleProducts);
  } else if (state.originalHTML) {
    grid.innerHTML = state.originalHTML;
  }

  const loadMoreBtn = $('[data-ttqp-load-more]', panel);
  if (loadMoreBtn) {
    if (state.allProducts && state.loadedCount < state.allProducts.length) {
      loadMoreBtn.style.display = '';
    } else {
      const stillHidden = panel.querySelectorAll('.ttqp-card.is-hidden').length;
      loadMoreBtn.style.display = stillHidden > 0 ? '' : 'none';
    }
  }

  bindQueueButtons(panel);
  syncGridButtonsWithQueue();
  updateSelectionCount();
}

function initSearch() {
  $$('.ttqp').forEach((section) => {
    const input = $('[data-ttqp-search]', section);
    if (!input) return;

    let timer;

    input.addEventListener('input', () => {
      window.clearTimeout(timer);

      timer = window.setTimeout(async () => {
        const q = input.value.trim().toLowerCase();
        const panels = $$('[data-ttqp-panel]', section);

        if (!q) {
          panels.forEach((panel) => restorePanelAfterSearch(panel));
          return;
        }

        let firstMatchedPanelId = null;

        for (const panel of panels) {
          const grid = $('[data-ttqp-grid]', panel);
          if (!grid) continue;

          const state = ensurePanelState(panel);
          const source = panel.getAttribute('data-ttqp-source');

          if (!state.originalHTML) {
            state.originalHTML = grid.innerHTML;
          }

          let productsForSearch = null;

          if (source === 'collection') {
            productsForSearch = await ensureAllCollectionProductsForPanel(panel);
          }

          // Manual tabs fallback to currently rendered cards only
          if (!productsForSearch) {
            const cards = $$('[data-ttqp-card]', panel).map((card) => ({
              title: card.getAttribute('data-title') || '',
              description: '',
              url: $('.ttqp-card__title a', card)?.getAttribute('href') || '#',
              featured_image: $('.ttqp-card__media img', card)?.getAttribute('src') || '',
              variant_id: $('.ttqp-add-to-queue', card)?.getAttribute('data-variant-id') || '',
              handle: ''
            }));
            productsForSearch = cards;
          }

          const matched = productsForSearch.filter((p) => {
            const title = (p.title || '').toLowerCase();
            const desc = (p.description || '').toLowerCase();
            return title.includes(q) || desc.includes(q);
          });

          if (matched.length > 0 && !firstMatchedPanelId) {
            firstMatchedPanelId = panel.getAttribute('data-ttqp-panel');
          }

          grid.innerHTML = matched.length
            ? renderProductCardsHTML(matched)
            : `<p class="ttqp__empty" style="grid-column:1/-1;">No matching scents found.</p>`;

          const loadMoreBtn = $('[data-ttqp-load-more]', panel);
          if (loadMoreBtn) loadMoreBtn.style.display = 'none';

          bindQueueButtons(panel);
          syncGridButtonsWithQueue();
        }

        if (firstMatchedPanelId) {
          setActiveTab(section, firstMatchedPanelId, true);
        }
      }, 120);
    });
  });
}
/*

  function applySearchFilter(section, query) {
    const panel = $('.ttqp__panel.is-active', section);
    if (!panel) return;

    const q = (query || '').trim().toLowerCase();
    const cards = $$('[data-ttqp-card]', panel);
    const loadMoreBtn = $('[data-ttqp-load-more]', panel);

    if (q.length > 0) {
      cards.forEach(c => c.classList.remove('is-hidden'));
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    } else {
      if (loadMoreBtn) loadMoreBtn.style.display = '';
    }

    let visibleCount = 0;
    cards.forEach((card) => {
      const title = (card.getAttribute('data-title') || '').toLowerCase();
      const match = q === '' ? true : title.includes(q);
      card.classList.toggle('is-filtered', !match);
      if (match) visibleCount++;
    });

    let empty = $('.ttqp__search-empty', panel);
    if (!empty) {
      panel.insertAdjacentHTML('beforeend', `<p class="ttqp__empty ttqp__search-empty" style="display:none;margin-top:14px;">No matching scents found.</p>`);
      empty = $('.ttqp__search-empty', panel);
    }
    if (empty) empty.style.display = (q && visibleCount === 0) ? 'block' : 'none';
  }

  function initSearch() {
    $$('.ttqp').forEach((section) => {
      const input = $('[data-ttqp-search]', section);
      if (!input) return;

      let t;
      input.addEventListener('input', () => {
        window.clearTimeout(t);
        t = window.setTimeout(() => applySearchFilter(section, input.value), 80);
      });
    });
  }
 */
  /* =========================================
     Load more
     ========================================= 
  function initLoadMore() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ttqp-load-more]');
      if (!btn) return;

      const panel = btn.closest('[data-ttqp-panel]');
      if (!panel) return;

      const section = btn.closest('.ttqp');
      const search = section ? $('[data-ttqp-search]', section) : null;
      if (search && search.value.trim().length > 0) return;

      const pageSize = Number(btn.getAttribute('data-page-size') || 6);
      const hiddenCards = Array.from(panel.querySelectorAll('.ttqp-card.is-hidden'));

      hiddenCards.slice(0, pageSize).forEach(card => card.classList.remove('is-hidden'));

      const stillHidden = panel.querySelectorAll('.ttqp-card.is-hidden').length;
      if (stillHidden === 0) btn.style.display = 'none';

      bindQueueButtons(panel);
    });
  } */

    function initLoadMore() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ttqp-load-more]');
    if (!btn) return;

    const panel = btn.closest('[data-ttqp-panel]');
    if (!panel) return;

    const section = btn.closest('.ttqp');
    const search = section ? $('[data-ttqp-search]', section) : null;
    if (search && search.value.trim().length > 0) return;

    const grid = $('[data-ttqp-grid]', panel);
    if (!grid) return;

    const pageSize = Number(panel.getAttribute('data-page-size') || btn.getAttribute('data-page-size') || 6);
    const state = ensurePanelState(panel);

    const allProducts = await ensureAllCollectionProductsForPanel(panel);

    if (Array.isArray(allProducts) && allProducts.length > 0) {
      if (!state.originalHTML) {
        state.originalHTML = grid.innerHTML;
      }

      if (!state.loadedCount || state.loadedCount < pageSize) {
        state.loadedCount = pageSize;
      } else {
        state.loadedCount += pageSize;
      }

      const visibleProducts = allProducts.slice(0, state.loadedCount);
      grid.innerHTML = renderProductCardsHTML(visibleProducts);

      bindQueueButtons(panel);
      syncGridButtonsWithQueue();
      updateSelectionCount();

      if (state.loadedCount >= allProducts.length) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }

      return;
    }

    // fallback for manual-product tabs
    const hiddenCards = Array.from(panel.querySelectorAll('.ttqp-card.is-hidden'));
    hiddenCards.slice(0, pageSize).forEach(card => card.classList.remove('is-hidden'));

    const stillHidden = panel.querySelectorAll('.ttqp-card.is-hidden').length;
    if (stillHidden === 0) btn.style.display = 'none';

    bindQueueButtons(panel);
    syncGridButtonsWithQueue();
    updateSelectionCount();
  });
}
  

  /* =========================================
     Subscribe Now
     ========================================= */
  function queueToLineItemProperties(queue) {
    const props = {};
    const months = getNextMonths(TTQP_CONFIG.MONTHS_COUNT);
    for (const ym of months) {
      const key = shortMonthLabelFromYM(ym);
      props[key] = queue[ym] ? queue[ym].title : TTQP_CONFIG.EMPTY_LABEL;
    }
    return props;
  }

  async function clearCart() {
    await fetch('/cart/clear.js', { method: 'POST' });
  }

  async function addSubscriptionToCart(properties) {
    if (!TTQP_CONFIG.SUB_VARIANT_ID || !TTQP_CONFIG.SELLING_PLAN_ID) {
  alert('Subscription product or selling plan not found. Please select a valid Subscription product in the section settings (with selling plans enabled).');
  return;
}

    const payload = {
      items: [{
        id: Number(TTQP_CONFIG.SUB_VARIANT_ID),
        quantity: 1,
        selling_plan: Number(TTQP_CONFIG.SELLING_PLAN_ID),
        properties
      }]
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  async function handleSubscribeNow() {
    const queue = loadQueue();
    const props = queueToLineItemProperties(queue);

    try {
      if (TTQP_CONFIG.CLEAR_CART_BEFORE_ADD) await clearCart();
      await addSubscriptionToCart(props);
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Could not add subscription to cart. Please try again.');
    }
  }

  function updateSelectionCount(){

  const queue = loadQueue();
  const count = Object.keys(queue).length;

  document.querySelectorAll('.ttqp-selection__count').forEach((el) => {
    el.textContent = count;
  });

}

  /* =========================================
     Single global click handler (clean)
     ========================================= */
 function initGlobalClicks() {
  document.addEventListener('click', (e) => {
    const t = e.target;

    if (t.closest('[data-ttqp-open-popup]')) { openModal(); return; }
    if (t.closest('[data-ttqp-close]')) { closeModal(); return; }

    const rmMonth = t.closest('[data-ttqp-remove-month]');
    if (rmMonth) { 
      removeMonthAndShift(rmMonth.getAttribute('data-ym'));
      updateSelectionCount();
      return; 
    }

    const rmVar = t.closest('[data-ttqp-remove-variant]');
    if (rmVar) { 
      removeVariantAndShift(rmVar.getAttribute('data-variant-id')); 
      updateSelectionCount();
      return; 
    }

    if (t.closest('#ttqpSubscribeNow')) { 
      handleSubscribeNow(); 
      return; 
    }

    const prev = t.closest('[data-ttqp-prev]');
    const next = t.closest('[data-ttqp-next]');
    const c = $('#ttqpCarousel');
    if (c && prev) c.scrollBy({ left: -420, behavior: 'smooth' });
    if (c && next) c.scrollBy({ left: 420, behavior: 'smooth' });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const m = $('#ttqpModal');
      if (m && m.classList.contains('is-open')) closeModal();
    }
  });
}




const TTQP_COLLECTION_CACHE = {};

async function fetchCollectionProducts(handle) {
  if (!handle) return [];
  if (TTQP_COLLECTION_CACHE[handle]) return TTQP_COLLECTION_CACHE[handle];

  let allProducts = [];
  let page = 1;
  let keepGoing = true;

  while (keepGoing) {
    const url = `/collections/${handle}/products.json?limit=250&page=${page}`;
    const res = await fetch(url, { credentials: 'same-origin' });

    if (!res.ok) {
      keepGoing = false;
      break;
    }

    const data = await res.json();
    const products = Array.isArray(data.products) ? data.products : [];

    if (!products.length) {
      keepGoing = false;
      break;
    }

    const normalized = products.map((product) => {
      const firstVariant = Array.isArray(product.variants) && product.variants.length
        ? product.variants[0]
        : null;

      const firstImage = Array.isArray(product.images) && product.images.length
        ? product.images[0]?.src
        : product.image?.src || '';

      return {
        id: product.id,
        title: product.title || '',
        handle: product.handle || '',
        url: `/products/${product.handle}`,
        featured_image: firstImage || '',
        variant_id: firstVariant ? firstVariant.id : '',
        description: (product.body_html || '')
          .replace(/<[^>]*>/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      };
    });

    allProducts = allProducts.concat(normalized);

    // if returned less than 250, we reached the end
    if (products.length < 250) {
      keepGoing = false;
    } else {
      page += 1;
    }
  }

  TTQP_COLLECTION_CACHE[handle] = allProducts;
  return allProducts;
}


function renderProductCardsHTML(products) {
  return products.map((product) => {
    const imageHtml = product.featured_image
      ? `<img src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">`
      : '';

    return `
      <article class="ttqp-card" data-ttqp-card data-title="${escapeHtml(product.title)}">
        <a class="ttqp-card__media" href="${product.url}" aria-label="${escapeHtml(product.title)}">
          ${imageHtml}
        </a>

        <div class="ttqp-card__body">
          <h3 class="ttqp-card__title">
            <a href="${product.url}">${escapeHtml(product.title)}</a>
          </h3>

          <p class="ttqp-card__desc">${escapeHtml(product.description || '')}</p>

          <div class="ttqp-queuebtn" data-ttqp-queuebtn>
            <button
              type="button"
              class="ttqp-card__btn ttqp-add-to-queue"
              data-title="${escapeHtml(product.title)}"
              data-image="${product.featured_image ? escapeHtml(product.featured_image) : ''}"
              data-variant-id="${product.variant_id ? escapeHtml(String(product.variant_id)) : ''}"
            >
              ADD TO QUEUE
            </button>

            <div class="ttqp-card__added" data-ttqp-added style="display:none;">
              <span>Added</span>
              <button
                type="button"
                class="ttqp-added__x"
                aria-label="Remove from queue"
                data-ttqp-remove-variant
                data-variant-id="${product.variant_id ? escapeHtml(String(product.variant_id)) : ''}"
              >×</button>
            </div>
          </div>
        </div>
      </article>
    `;
  }).join('');
}

function ensurePanelState(panel) {
  if (!panel._ttqpState) {
    panel._ttqpState = {
      loadedCount: 0,
      allProducts: null,
      isSearching: false,
      originalHTML: null
    };
  }
  return panel._ttqpState;
}

async function ensureAllCollectionProductsForPanel(panel) {
  const state = ensurePanelState(panel);
  if (state.allProducts) return state.allProducts;

  const source = panel.getAttribute('data-ttqp-source');
  const handle = panel.getAttribute('data-ttqp-collection-handle');

  if (source !== 'collection' || !handle) {
    return null;
  }

  state.allProducts = await fetchCollectionProducts(handle);
  return state.allProducts;
}

  /* =========================================
     Init
     ========================================= */
  function init() {

    hydrateConfigFromDOM();  
    ensureModal();
    initGlobalClicks();
    initTabs();
    initSearch();
    initLoadMore();
    updateSelectionCount();

    bindQueueButtons(document);
    syncGridButtonsWithQueue();

    const obs = new MutationObserver(() => {
      bindQueueButtons(document);
      syncGridButtonsWithQueue();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
})();